import { CategoryWifiProfileConfiguration, ModelNameFlags } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationResolverActions = createActionGroup({
  source: 'Category wifi profile preset configuration resolver',
  events: {
    'Category wifi profile preset configurations requested': props<{
      category: Category;
      modelNames: ModelNameFlags[];
    }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Category wifi profile preset configuration API',
  events: {
    'Category wifi profile preset configurations loaded': props<{
      wifiProfiles: CategoryWifiProfileConfiguration[];
    }>(),
    'Category wifi profile preset configurations loaded error': props<{ error: ErrorModel }>(),
    'Category wifi profile preset configurations updated': props<{
      category: Category;
      wifiProfiles: CategoryWifiProfileConfiguration[];
    }>(),
    'Category wifi profile preset configurations updated error': props<{
      category: Category;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Category wifi profile preset configuration view',
  events: {
    'Wifi profile preset configurations updated': props<{
      category: Category;
      updatedWifiProfilesLinkedToCategory: CategoryWifiProfileConfiguration[];
    }>(),
  },
});

// ============================================================================
// EFFECT ACTIONS
// ============================================================================

export const CategoryWifiProfilePresetConfigurationEffectActions = createActionGroup({
  source: 'Category wifi profile preset configuration effects',
  events: {
    'Category wifi profile preset configurations requested': props<{
      category: Category;
      modelNames: ModelNameFlags[];
    }>(),
  },
});
